import { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import { PiHandshakeDuotone } from "react-icons/pi";

import Marquee from "../components/marquee";

import sj1 from './../media/img/sj1.jpg'
import sj2 from './../media/img/sj2.jpg'

import si1 from './../media/img/si1.jpg'
import silogo from './../media/img/si-logo-single.png'
import telegram from './../media/img/telegram.png'
import twitter from './../media/img/twitter.png'



const Home = () => {


    const [htwCount, setHtwcount] = useState(0)
    const [textca, setTextca] = useState("3VbeSPsdKWaGcXk4AczVGYRiA8m9YomooYMUgKHzpump");

    const [loading, setloading] = useState(true)
    const [windowWidth, setWindowWidth] = useState(window.innerWidth)

    const texts = ['$SUIJERRY', '$SUIJERRY', '$SUIJERRY', '$SUIJERRY', '$SUIJERRY','$SUIJERRY','$SUIJERRY','$SUIJERRY','$SUIJERRY','$SUIJERRY','$SUIJERRY','$SUIJERRY','$SUIJERRY','$SUIJERRY','$SUIJERRY','$SUIJERRY','$SUIJERRY','$SUIJERRY'];

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
            console.log(window.innerWidth)
        };

        window.addEventListener('resize', handleResize);

        // Cleanup: Remove the event listener when the component is unmounted
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const copyToClipboard = () => {
        navigator.clipboard
        .writeText(textca)
        .then(() => {
            alert("ca copied to clipboard!");
        })
        .catch((err) => {
            console.error("Failed to copy ca: ", err);
        });
    };

    const LoadingComp = () => (
        <div className={`onLoading`}>
            <div className="onLoading-box">
                {/* <img src={cocowho} alt="" /> */}
            </div>
        </div>
    )


    useEffect(() => {
        const timer = setTimeout(() => {
        setloading(null);
        }, 6000);

        return () => clearTimeout(timer);
    }, []);

    // if (loading) {
    //     return <LoadingComp />;
    // }


    return ( 
        <div className="">

            {/* {LoadingComp()} */}

            <section id="home" className="home">
                <div className="main-frame">
                    <div className="flex justify-center align-flex-end home-frame">

                        <div className="home-img-logo">
                            {/* <img src={silogo} alt="" /> */}
                        </div>

                    </div>
                </div>
            </section>

            <Marquee texts={texts} speed={100} />

            <section className="about" id="about">

                <h2>WHO'S SUI JERRY</h2>

                <div className="flex row wrap align-center justify-center gap-20 mgb-90">

                    <div className="about-img">
                        <img src={sj2} alt="" />
                    </div>

                    <div className="">
                        <div className="about-text mgb-20">
                            <h3 className="text-align-center">
                                I’m JERRY. <br />
                                Cheeky little legend racing across the Sui Network<br /><br />

                                Inspired by the classic cartoon icon but powered by next-gen blockchain speed, SUI JERRY is fast, clever, and impossible to catch.<br /><br />

                                This is a million dollar sendor!
                            </h3>
                        </div>
                        <a className="about-buy-btn">
                            BUY NOW
                        </a>
                    </div>


                </div>

                <div className="mgb-24 text-align-center">
                    <h4>
                        Copyright © 2025 SUI JERRY.<br />
                        All rights reserved.
                    </h4>
                </div>
                <div className="flex gap-15 justify-center row header-icon-row">
                    <a href='https://t.me/SuiJerryPortal' target='_blank'>
                        <img src={telegram} alt="" />
                    </a>
                    <a href='https://x.com/suiandjerry' target='_blank'>
                        <img src={twitter} alt="" />
                    </a>
                </div>
            </section>

        </div>
    );
}
 
export default Home;